(function () {
  function pickerForHandle(handle) {
    return document.querySelector(`variant-picker[data-product-handle="${CSS.escape(handle)}"]`);
  }

  function selectedOption(picker) {
    return (
      picker?.querySelector('input:checked[data-dl-variant-images]') ||
      picker?.querySelector('select option:checked[data-dl-variant-images]')
    );
  }

  function selectedChoice(picker) {
    return picker?.querySelector('input:checked') || picker?.querySelector('select option:checked') || null;
  }

  function optionFromControl(control) {
    if (control instanceof HTMLSelectElement) {
      return control.selectedOptions[0] || null;
    }

    return control;
  }

  function imageUrls(option) {
    return (option?.dataset.dlVariantImages || '')
      .split('|')
      .map((url) => url.trim())
      .filter(Boolean);
  }

  function galleryForPicker(picker) {
    return picker?.closest('.shopify-section')?.querySelector('media-gallery') ||
      document.querySelector('#MainContent media-gallery');
  }

  function preloadVariantImages() {
    const urls = new Set();

    document.querySelectorAll('[data-dl-variant-images]').forEach((option) => {
      imageUrls(option).forEach((url) => urls.add(url));
    });

    urls.forEach((url) => {
      const image = new Image();
      image.decoding = 'async';
      image.src = url;
    });
  }

  function removeVariantGallery(handle, picker) {
    const gallery = galleryForPicker(picker);
    gallery?.querySelector('.dl-variant-gallery')?.remove();
    gallery?.classList.remove('dl-variant-gallery-ready');

    if (document.documentElement.dataset.dlVariantSetActive === handle) {
      delete document.documentElement.dataset.dlVariantSetActive;
    }
  }

  function updateVariantCopy(option, picker) {
    if (!option || !picker) return;

    const productSection = picker.closest('.shopify-section');
    const title = productSection?.querySelector('h1');

    if (title) {
      title.dataset.dlOriginalText ||= title.textContent.trim();
      title.textContent = option.dataset.dlVariantTitle || title.dataset.dlOriginalText;
    }

    const description = productSection?.querySelector('.accordion accordion-custom details .details-content p');
    if (description) {
      description.dataset.dlOriginalText ||= description.textContent.trim();
      description.textContent = option.dataset.dlVariantCopy || description.dataset.dlOriginalText;
    }
  }

  function buildVariantGallery(handle, picker, option) {
    const urls = imageUrls(option);
    if (!urls.length) {
      removeVariantGallery(handle, picker);
      return;
    }

    const gallery = galleryForPicker(picker);
    if (!gallery) return;

    document.documentElement.dataset.dlVariantSetActive = handle;

    const previousGallery = gallery.querySelector('.dl-variant-gallery');
    const currentSignature = previousGallery?.dataset.variantSignature || '';
    const nextSignature = urls.join('|');

    if (previousGallery && currentSignature === nextSignature) {
      gallery.classList.add('dl-variant-gallery-ready');
      return;
    }

    previousGallery?.remove();

    const variantGallery = document.createElement('div');
    variantGallery.className = 'dl-variant-gallery';
    variantGallery.dataset.variantSignature = nextSignature;
    variantGallery.setAttribute('role', 'region');
    variantGallery.setAttribute('aria-label', `${option.dataset.dlVariantAlt || 'Variante seleccionada'}: ${urls.length} vistas`);

    const thumbnails = document.createElement('div');
    thumbnails.className = 'dl-variant-gallery__thumbnails';
    thumbnails.setAttribute('role', 'tablist');
    thumbnails.setAttribute('aria-label', 'Vistas del producto');

    const stage = document.createElement('figure');
    stage.className = 'dl-variant-gallery__stage';

    const mainImage = document.createElement('img');
    mainImage.className = 'dl-variant-gallery__image';
    mainImage.src = urls[0];
    mainImage.alt = `${option.dataset.dlVariantAlt || 'Variante seleccionada'} — vista 1`;
    mainImage.decoding = 'async';
    mainImage.loading = 'eager';
    mainImage.fetchPriority = 'high';
    stage.append(mainImage);

    const counter = document.createElement('span');
    counter.className = 'dl-variant-gallery__counter';
    counter.setAttribute('aria-live', 'polite');
    counter.textContent = `1 / ${urls.length}`;
    stage.append(counter);

    function selectImage(index) {
      mainImage.src = urls[index];
      mainImage.alt = `${option.dataset.dlVariantAlt || 'Variante seleccionada'} — vista ${index + 1}`;
      counter.textContent = `${index + 1} / ${urls.length}`;

      thumbnails.querySelectorAll('.dl-variant-gallery__thumbnail').forEach((button, buttonIndex) => {
        const selected = buttonIndex === index;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
      });
    }

    urls.forEach((url, index) => {
      const button = document.createElement('button');
      button.className = 'dl-variant-gallery__thumbnail';
      button.type = 'button';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', `Mostrar vista ${index + 1} de ${urls.length}`);
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
      button.tabIndex = index === 0 ? 0 : -1;
      if (index === 0) button.classList.add('is-active');

      const image = document.createElement('img');
      image.className = 'dl-variant-gallery__thumbnail-image';
      image.src = url;
      image.alt = `${option.dataset.dlVariantAlt || 'Variante seleccionada'} — vista ${index + 1}`;
      image.decoding = 'async';
      image.loading = 'eager';

      button.append(image);
      button.addEventListener('click', () => selectImage(index));
      thumbnails.append(button);
    });

    variantGallery.append(thumbnails, stage);

    gallery.prepend(variantGallery);
    gallery.classList.add('dl-variant-gallery-ready');
  }

  function applyVariantSet(handle, option) {
    const picker = pickerForHandle(handle);
    if (!picker) return;

    const currentOption = option || selectedChoice(picker);
    updateVariantCopy(currentOption, picker);
    const activeOption = currentOption?.matches?.('[data-dl-variant-images]') ? currentOption : selectedOption(picker);

    if (!activeOption) {
      removeVariantGallery(handle, picker);
      return;
    }

    buildVariantGallery(handle, picker, activeOption);
  }

  function applyInitialSelections() {
    preloadVariantImages();

    document.querySelectorAll('variant-picker[data-product-handle]').forEach((picker) => {
      applyVariantSet(picker.dataset.productHandle || '');
    });
  }

  document.addEventListener(
    'change',
    (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;

      const picker = control.closest('variant-picker[data-product-handle]');
      const handle = picker?.dataset.productHandle || '';
      if (!handle) return;

      applyVariantSet(handle, optionFromControl(control));
    },
    true
  );

  document.addEventListener('shopify:product:select', (event) => {
    const handle = event.product?.handle || event.target?.dataset?.productHandle || '';
    if (!handle || !event.promise) return;

    event.promise
      .then(() => {
        requestAnimationFrame(() => applyVariantSet(handle));
      })
      .catch(() => {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyInitialSelections, { once: true });
  } else {
    applyInitialSelections();
  }
})();
